
import { useContext, useMemo } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'
import useNavigation from './useNavigation'
import { SCENARIO_GENERIC_TYPES } from '../../constants'
import { DeploymentType, OperationType } from '../../types'

const useScenarioResponse = () => {
    const context = useContext(ScenarioStatesProviderContext)
    const { type } = useNavigation()
    if (context === undefined) {
        throw new Error('useScenarioResponse must be used within a Scenario States Provider')
    }
    const setScenarioResponse = useMemo(() => context.setScenarioResponse, [context.setScenarioResponse])
    const scenarioResponse = useMemo(() => context.scenarioResponse, [context.scenarioResponse])
    const scenarioOperationType: OperationType = useMemo(() => scenarioResponse?.scenarioOperation as OperationType, [scenarioResponse?.scenarioOperation])
    const scenarioDeploymentType: DeploymentType = useMemo(() => scenarioResponse?.scenarioDeploymentType as DeploymentType, [scenarioResponse?.scenarioDeploymentType])
    const scenarioStatus = useMemo(() => scenarioResponse?.status, [scenarioResponse?.status])
    const openScenario = useMemo(() => type === SCENARIO_GENERIC_TYPES.OPENCENARIO, [type])
    return { scenarioResponse, setScenarioResponse, scenarioOperationType, scenarioDeploymentType, scenarioStatus, openScenario }
}

export default useScenarioResponse